<template>
    <div id="JobPostingList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Job List</div>
                    <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                    <!-- <router-link v-if="canAddJob" class="btn btn-primary pull-right" v-bind:to="{name: 'JobPostingCreate'}" > <i class="fp-add"> </i> Add</router-link> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content news-list">
                        <data-table-filter-config :moduleName="'jobList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'jobList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listJobsTable"
                                    mode="remote"
                                    title="Job"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                      enabled: canRemoveJob,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                      <div slot="selected-row-actions">
                                          <button v-if="canRemoveJob" id="deleteJobBtn" v-on:click.prevent="jobDelete" class="btn btn-danger">Delete</button>
                                      </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "JobList",
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Job Id',
                    field: 'id',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Queue',
                    field: 'queue',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Queue", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Payload',
                    field: 'payload',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Payload", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Attempts',
                    field: 'attempts',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false
                },
                {
                    label: 'Reserved At',
                    field: 'reserved_at',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false
                },
                {
                    label: 'Available At',
                    field: 'available_at',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Created At", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            canUpdateJob:false,
            canAddJob:false,
            canRemoveJob:false,
            action:'list'
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_job') {
                            self.cantAccessPage = true;
                        }

                        if (permissions[i].name == 'delete_job') {
                            self.canRemoveJob = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listNewsTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                var data = this.$refs['listJobsTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listJobsTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action:self.action,
                    selectedRows:use
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/jobs/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            if (self.action == 'delete'){
                                self.$swal('',data.message,'success');
                                self.action = 'list';
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'news-list');
                    }
                });
            },

            jobDelete() {
                var data = this.$refs['listJobsTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listJobsTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Job? ')) {
                    self.action = 'delete';
                    self.loadList();
                }
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/JobsList.vue